import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Course, Instructor } from "../../types/types";
export type CoursesDTO = Course & {
  enrolled?: boolean;
  Instructor: Instructor;
  _count: {
    students?: number;
  };
  startDate?: string;
  isLive?: boolean;
};

interface CoursesData {
  coursesData: CoursesDTO[];
}
interface CoursesResponse {
  data?: CoursesData;
  error?: ApiError;
}

export const getCourses = async (): Promise<CoursesResponse> => {
  try {
    const response = await axios.get("/course/all");

    return { data: { coursesData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
